<template>
  <div class="pagination">
    <span :class="{'is-active': item.active, 'is-disabled': !item.url }" v-for="(item, i) in link" :key="i" @click="callback(item)">{{ item.label }}</span>
  </div>
</template>

<script>
export default {
  name:'', 
  data () {
    return {

    }
  },
  props: {
    link: Array
  },
  methods: {
    callback({url, active}) {
      if(url && !active) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        this.$emit('page-change', url)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pagination {
  display: flex;
  justify-content: flex-end;
  margin: 0.9615rem 0.7692rem;
  column-gap: 10px;
  font-size: 0.6923rem;
  span {
    cursor: pointer;
    user-select: none;
    display: block;
    min-width: 1.1538rem;
    height: 1.1538rem;
    line-height: 1.1538rem;
    text-align: center;
    background: #f4f4f5;
    color: #606266;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 0 0.1538rem;
  }
  .is-active {
    background: #ff7802;
    color: #fff;
  }
  .is-disabled {
    cursor: no-drop;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/pagination.vue